import styled, { css } from 'styled-components'
import { fontType, mediaQuery, toRem } from '../../shared/styles/functions'



interface props {
	variation: 1 | 2
}

export const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 80px;
	background: ${(props) => props.theme.COLORS.summary_background};

	${mediaQuery('sm')(`
	    padding: 80px 8px;
    `)}
`

export const Content = styled.div`
	width: 100%;
	max-width: 600px;
	margin-bottom: 32px;
`

export const Title = styled.h1`
	${fontType(3)}
	font-size: ${toRem(40)};
	color: ${({ theme }) => theme.COLORS.BLACK};
	text-align: center;
	margin-bottom: 40px;
`

export const PaymentTypeContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 24px;
`



export const LoadingText = styled.span`
	font-size: ${toRem(24)};
	${fontType(2)}
	color: ${({ theme }) => theme.COLORS.BLACK};
	margin-bottom: 32px;
	text-align: center;
`

export const StatusContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
`
export const StatusMessage = styled.span`
	font-size: ${toRem(40)};
	${fontType(3)}
	color: ${({ theme }) => theme.COLORS.BLACK};
	text-align: center;
	margin-bottom: 40px;
`


export const Hr = styled.hr`
	width: 100%;
	border-top: 1px solid ${({ theme }) => theme.COLORS.LIGHT_GRAFFITI};
	opacity: 0.5;
	margin: 50px 0 32px;
`

export const CopyText = styled.span`
	color: ${({ theme }) => theme.COLORS.BLACK};
	text-align: center;
	font-size: ${toRem(16)};
	${fontType(1)}
	margin-bottom:  24px;
	overflow: hidden;

	${mediaQuery('xs')(`
	font-size: ${toRem(20)};
	`)}
`

export const Button = styled.button<props>`
	height: 53px;
	border-radius: 5px;
	padding: 0 48px;
	text-align: center;
	text-transform: uppercase;
	font-size: ${toRem(16)};
	${fontType(2)};

	${({ theme, variation }) => {
		switch (variation) {
			case 2:
				return css`
					background: ${theme.COLORS.WHITE};
					color: ${theme.COLORS.BLACK};
				`

			default:
				return css`
					background: ${theme.COLORS.BLACK};
					color: ${theme.COLORS.WHITE};
				`
		}
	}};
`

export const ThankyouMessage = styled.p`
	font-size: ${toRem(16)};
	${fontType(1)}
	color: ${({ theme }) => theme.COLORS.BLACK};
	text-align: center;
	margin-bottom: 14px;

	${mediaQuery('xs')(`
	font-size: ${toRem(20)};
	`)}
`


export const FailureMessage = styled.p`
	font-size: ${toRem(16)};
	${fontType(1)}
	color: ${({ theme }) => theme.COLORS.BLACK};
	text-align: center;
	margin-bottom: 64px;

	${mediaQuery('xs')(`
	font-size: ${toRem(20)};
	`)}
`

export const LoadingContainer = styled.div`
	background: ${({ theme }) => theme.COLORS.WHITE};
	box-shadow: 0px 2px 3px #00000029;
	border-radius: 5px;
	padding: 56px 40px;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	max-width: 490px;
	aspect-ratio: 1/1;
	justify-content: center;
	margin: 50px auto;
`

export const ImagesContainer = styled.div`
	width: 100%;
	margin: 0 auto 50px auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 100px 20px;
`
